import Vue from 'vue'
import Router from 'vue-router'
//import mainPort from '../components/main/FirstNav/FirstNav.vue'
//import login from '../components/login/login.vue'
// 二级导航
const homeNav = resolve => require(['@/components/main/SecondNav/homeNav.vue'],resolve)
const EcNav = resolve => require(['@/components/main/SecondNav/EcNav.vue'],resolve)
const MDNav = resolve => require(['@/components/main/SecondNav/MDNav.vue'],resolve)
const ENNav = resolve => require(['@/components/main/SecondNav/ENNav.vue'],resolve)
const GDNav = resolve => require(['@/components/main/SecondNav/GDNav.vue'],resolve)
const SetNav = resolve => require(['@/components/main/SecondNav/SetNav.vue'],resolve)
const help = resolve => require(['@/components/main/SecondNav/help.vue'],resolve)


//系统设置
	//普通用户
const xtSetting  = resolve => require(['@/components/main/setting/xtSetting.vue'],resolve)
const ztSetting  = resolve => require(['@/components/main/setting/ztSetting.vue'],resolve)
const xtNotice  = resolve => require(['@/components/main/setting/xtNotice.vue'],resolve)
const popularization  = resolve => require(['@/components/main/setting/popularization.vue'],resolve)
const usermanual = resolve => require(['@/components/main/setting/usermanual.vue'], resolve)
	//管理员账号
const adminxtSetting  = resolve => require(['@/components/main/setting/adminxtSetting.vue'],resolve)


//电气火灾
	//普通用户
const DetectorList = resolve => require(['@/components/main/ElectricalFire/DetectorList.vue'],resolve)
const crtMap = resolve => require(['@/components/main/ElectricalFire/crtMap.vue'],resolve)
const AlarmHistory = resolve => require(['@/components/main/ElectricalFire/AlarmHistory.vue'],resolve)
const Report = resolve => require(['@/components/main/ElectricalFire/Report.vue'],resolve)
const Overview = resolve => require(['@/components/main/ElectricalFire/Overview.vue'],resolve)
const EFalarming = resolve => require(['@/components/main/ElectricalFire/EFalarming.vue'],resolve)
const service = resolve => require(['@/components/main/ElectricalFire/service.vue'],resolve)

	//管理员账号下的电气火灾页面
const adminOverview = resolve => require(['@/components/main/ElectricalFire/adminOverview.vue'],resolve)
const admincrtMap = resolve => require(['@/components/main/ElectricalFire/admincrtMap.vue'],resolve)
const adminAlarmHistory = resolve => require(['@/components/main/ElectricalFire/adminAlarmHistory.vue'],resolve)
const adminReport = resolve => require(['@/components/main/ElectricalFire/adminReport.vue'],resolve)
const adminDetectorList = resolve => require(['@/components/main/ElectricalFire/adminDetectorList.vue'],resolve)
const adminEFalarming = resolve => require(['@/components/main/ElectricalFire/adminEFalarming.vue'],resolve)
const adminservice = resolve => require(['@/components/main/ElectricalFire/adminService.vue'],resolve)

//智能末端
const MDDetectorList = resolve => require(['@/components/main/MD/MDDetectorList.vue'],resolve)
const MDAlarmLog = resolve => require(['@/components/main/MD/MDAlarmLog.vue'],resolve)
	//管理员账号下的智能末端页面
const adminMDDetectorList = resolve => require(['@/components/main/MD/adminMDDetectorList.vue'],resolve)
const adminMDSheBeiList = resolve => require(['@/components/main/MD/adminMDSheBeiList.vue'],resolve)


//烟感
const YGDetectorList = resolve => require(['@/components/main/YG/YGDetectorList.vue'],resolve)
const YGAlarmLog = resolve => require(['@/components/main/YG/YGAlarmLog.vue'],resolve)
	//管理员账号下的智能末端页面
const adminYGDetectorList = resolve => require(['@/components/main/YG/adminYGDetector.vue'],resolve)
const adminYGSheBeiList = resolve => require(['@/components/main/YG/adminYGSheBeiList.vue'],resolve)
const adminYGAlarmLog = resolve => require(['@/components/main/YG/adminYGAlarmLog.vue'],resolve)

//能耗分析
const NengHao = resolve => require(['@/components/main/NengHao/nenghao.vue'],resolve)
const adminNengHao = resolve => require(['@/components/main/NengHao/adminNengHao.vue'],resolve)
const NengHaoBaoGao = resolve => require(['@/components/main/NengHao/NengHaoBaoGao.vue'],resolve)
const adminNengHaoBaoGao = resolve => require(['@/components/main/NengHao/adminNengHaoBaoGao.vue'],resolve)

//大数据分析
const bigData = resolve => require(['@/components/main/bigData/bigData.vue'],resolve)

//单独的
const mainPort = resolve => require(['@/components/main/FirstNav/FirstNav.vue'], resolve)
const login = resolve => require(['@/components/login/login.vue'], resolve)
const white = resolve => require(['@/components/base/white.vue'], resolve)
// 二级导航

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: __dirname,
  routes: [
    {
      path: '/mainPort',
      name:'mainPort',
      component:mainPort,
      children:[
      		 //空白页
		    {
		    	path:'/white',
		    	name:'white',
		    	component:white
		    },
	      	// 电气火灾
      		{
		      	path: '/mainPort/EcNav',
		     	name:'EcNav',
		     	component:EcNav,
		     	children:[
		     		//代理商模式
		     		{
		     			path:'/mainPort/EcNav/Overview',
		     			name:'Overview',
		     			component:Overview
		     		},
		     		{
		     			path:'/mainPort/EcNav/DetectorList',
		     			name:'DetectorList',
		     			component:DetectorList
		     		},
		     		{
		     			path:'/mainPort/EcNav/service',
		     			name:'service',
		     			component:service
		     		},
		     		{
		     			path:'/mainPort/EcNav/EFalarming',
		     			name:'EFalarming',
		     			component:EFalarming
		     		},
		     		{
		     			path:'/mainPort/EcNav/crtMap',
		     			name:'crtMap',
		     			component:crtMap
		     		},
		     		{
		     			path:'/mainPort/EcNav/AlarmHistory',
		     			name:'AlarmHistory',
		     			component:AlarmHistory
		     		},
		     		{
		     			path:'/mainPort/EcNav/Report',
		     			name:'Report',
		     			component:Report
		     		},
		     		//管理员模式
		     		{
		     			path:'/mainPort/EcNav/adminOverview',
		     			name:'adminOverview',
		     			component:adminOverview
		     		},
		     		{
		     			path:'/mainPort/EcNav/adminDetectorList',
		     			name:'adminDetectorList',
		     			component:adminDetectorList
		     		},
		     		{
		     			path:'/mainPort/EcNav/adminEFalarming',
		     			name:'adminEFalarming',
		     			component:adminEFalarming
		     		},
		     		{
		     			path:'/mainPort/EcNav/admincrtMap',
		     			name:'admincrtMap',
		     			component:admincrtMap
		     		},
		     		{
		     			path:'/mainPort/EcNav/adminAlarmHistory',
		     			name:'adminAlarmHistory',
		     			component:adminAlarmHistory
		     		},
		     		{
		     			path:'/mainPort/EcNav/adminReport',
		     			name:'adminReport',
		     			component:adminReport
		     		},
		     		{
		     			path:'/mainPort/EcNav/adminservice',
		     			name:'adminservice',
		     			component:adminservice
		     		},
		     	]
	      	},
	      	// 智能末端
      		{
		      	path: '/mainPort/MDNav',
		     	name:'MDNav',
		     	component:MDNav,
		     	children:[
		     		{
		     			path:'/mainPort/MDNav/MDDetectorList',
		     			name:'MDDetectorList',
		     			component:MDDetectorList
		     		},
		     		{
		     			path:'/mainPort/MDNav/MDAlarmLog',
		     			name:'MDAlarmLog',
		     			component:MDAlarmLog
		     		},
		     		//管理员模式
		     		{
		     			path:'/mainPort/MDNav/adminMDDetectorList',
		     			name:'adminMDDetectorList',
		     			component:adminMDDetectorList
		     		},
		     		{
		     			path:'/mainPort/MDNav/adminMDSheBeiList',
		     			name:'adminMDSheBeiList',
		     			component:adminMDSheBeiList
		     		}
		     	]
	      	},
	      	// 能耗系统
      		{
		      path: '/mainPort/ENNav',
		     	name:'ENNav',
		     	component:ENNav,
		     	children:[
		     		{
		     			path:'/mainPort/ENNav/NengHao',
		     			name:'NengHao',
		     			component:NengHao
		     		},
            {
              path:'/mainPort/ENNav/NengHaoBaoGao',
              name:'NengHaoBaoGao',
              component:NengHaoBaoGao
            },
		     		//管理员模式
		     		{
		     			path:'/mainPort/ENNav/adminNengHao',
		     			name:'adminNengHao',
		     			component:adminNengHao
		     		},
            {
              path:'/mainPort/ENNav/adminNengHaoBaoGao',
              name:'adminNengHaoBaoGao',
              component:adminNengHaoBaoGao
            }
		     	]
	      	},
	      	// 烟感
      		{
		      	path: '/mainPort/GDNav',
		     	name:'GDNav',
		     	component:GDNav,
		     	children:[
		     		{
		     			path:'/mainPort/GDNav/YGDetectorList',
		     			name:'YGDetectorList',
		     			component:YGDetectorList
		     		},
		     		{
		     			path:'/mainPort/GDNav/YGAlarmLog',
		     			name:'YGAlarmLog',
		     			component:YGAlarmLog
		     		},
		     		//管理员模式
		     		{
		     			path:'/mainPort/GDNav/adminYGDetectorList',
		     			name:'adminYGDetectorList',
		     			component:adminYGDetectorList
		     		},
		     		{
		     			path:'/mainPort/GDNav/adminYGSheBeiList',
		     			name:'adminYGSheBeiList',
		     			component:adminYGSheBeiList
		     		},
		     		{
		     			path:'/mainPort/GDNav/adminYGAlarmLog',
		     			name:'adminYGAlarmLog',
		     			component:adminYGAlarmLog
		     		}
		     	]
	      	},
	      	// 系统设置
      		{
		      	path: '/mainPort/SetNav',
		     	name:'SetNav',
		     	component:SetNav,
		     	children:[
		     		{
			     		path: '/mainPort/SetNav/xtSetting',
				     	name:'xtSetting',
				     	component:xtSetting,
			     	},
			     	{
			     		path: '/mainPort/SetNav/ztSetting',
				     	name:'ztSetting',
				     	component:ztSetting,
			     	},
			     	{
			     		path: '/mainPort/SetNav/xtNotice',
				     	name:'xtNotice',
				     	component:xtNotice,
			     	},
			     	// {
			     	// 	path: '/mainPort/SetNav/popularization',
				     // 	name:'popularization',
				     // 	component:popularization,
			     	// },
			     	{
			     		path: '/mainPort/SetNav/adminxtSetting',
				     	name:'adminxtSetting',
				     	component:adminxtSetting,
			     	}
		     	]
	      	},
	      	// 帮助
      		{
		          path: '/mainPort/help',
		     	      name:'help',
		     	      component:help,
		     	      children:
                [
      			     	{
      			     		path: '/mainPort/help/popularization',
      				     	name:'popularization',
      				     	component:popularization,
      			     	},
                  {
                    path: '/mainPort/help/usermanual',
                    name:'usermanual',
                    component:usermanual
                  }
      		     	]
	      	},
	        {
		        path: '/mainPort',
		        redirect: '/mainPort/SetNav/popularization'
		      }
      ]

    },
    // 首页
    {
		path: '/homeNav',
		name:'homeNav',
		component:homeNav
	},
	{
		path:'/bigData',
		name:'bigData',
		component:bigData
	},
    {
    	path:'/login',
    	name:'login',
    	component:login
    },

    {
      path: '*',
      redirect: '/login'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js